import React from 'react';

import PropTypes from 'prop-types';

import VerticalNavigation from '@/components/navigation/verticalNavigation/VerticalNavigation';
import * as PC_COMMON_FUNCTION from '@/libs/appHelper';

import './TextView.less';

const MAX_TEXT_AREA_SHOW = 12;
class TextArea extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textArealist: [
        'aaaaaa',
        'bbbbb',
        'cccccccc',
        'dddddd',
        'eeeeee',
        'fffffff',
        'aaaaaa',
        'bbbbb',
        'cccccccc',
        'dddddd',
        'eeeeee',
        'fffffff',
      ],
      lastTextAreaShowId: 0,
      showTextList: [],
      totalPage: 0,
      activePage: 0,
    };
  }

  // component will receive props
  static getDerivedStateFromProps(props, state) {
    const showTextList = [];
    const textArealist = props.textList;
    if (props.isFullView === false || props.isFullView === undefined) {
      if (props.textList !== state.textArealist && props.textList !== undefined) {
        for (let i = 0; i < MAX_TEXT_AREA_SHOW; i++) {
          showTextList[i] = textArealist[i];
        }
        const TotalPage = Math.ceil(textArealist.length / MAX_TEXT_AREA_SHOW);
        // initial state
        return {
          showTextList,
          // lastTextAreaShowId: i,
          textArealist,
          totalPage: TotalPage,
          activePage: TotalPage > 1 ? 1 : 0,
        };
      }
    } else {
      return {
        showTextList: textArealist,
        lastTextAreaShowId: 0,
        textArealist,
        totalPage: 1,
        activePage: 1,
      };
    }

    // Return null if the state hasn't changed
    return null;
  }

  /**
   * Set show cycle history
   * @param textList
   * @param beginingId
   * @param endId
   * @returns showTextList
   * @returns lastTextAreaShowId
   */
  setShowTextArea(textList, beginingId, endId) {
    const showTextList = [];
    for (let i = beginingId; i < endId; i++) {
      showTextList[i] = textList[i];
    }
    this.setState({
      showTextList,
      // lastTextAreaShowId: i,
    });
  }

  // initialShowText = (textArealist) => {
  //   if (textArealist === undefined) return;
  //   const showTextList = [];
  //   for (let i = 0; i < MAX_TEXT_AREA_SHOW; i++) {
  //     showTextList[i] = textArealist[i];
  //   }
  //   const TotalPage = Math.ceil(textArealist.length / MAX_TEXT_AREA_SHOW);
  //   this.setState({
  //     showTextList,
  //     // lastTextAreaShowId: i,
  //     textArealist,
  //     totalPage: TotalPage,
  //     activePage: TotalPage > 1 ? 1 : 0,
  //   });
  // };

  onClick = (e) => {
    const {textArealist, lastTextAreaShowId, activePage, totalPage} = this.state;
    switch (e.currentTarget.id) {
      case VerticalNavigation.Button.NEXT: {
        this.actionNext(textArealist, lastTextAreaShowId);
        const newActivePage = activePage + 1;
        this.setState({
          activePage: newActivePage > totalPage ? 1 : newActivePage,
        });
        break;
      }
      case VerticalNavigation.Button.PREVIOUS: {
        this.actionPrevious(textArealist, lastTextAreaShowId);
        const newActivePage = activePage - 1;
        this.setState({
          activePage: newActivePage === 0 ? totalPage : newActivePage,
        });
        break;
      }
      default:
        break;
    }
  };

  actionPrevious(textList, lastTextAreaShowId) {
    const endId =
      // eslint-disable-next-line no-nested-ternary
      lastTextAreaShowId - MAX_TEXT_AREA_SHOW <= 0
        ? textList.length
        : lastTextAreaShowId % MAX_TEXT_AREA_SHOW === 0
        ? lastTextAreaShowId - MAX_TEXT_AREA_SHOW
        : PC_COMMON_FUNCTION.getTheBiggestMod(textList.length, MAX_TEXT_AREA_SHOW);
    const beginingId =
      endId % MAX_TEXT_AREA_SHOW === 0
        ? endId - MAX_TEXT_AREA_SHOW
        : PC_COMMON_FUNCTION.getTheBiggestMod(textList.length, MAX_TEXT_AREA_SHOW);
    this.setShowTextArea(textList, beginingId, endId);
  }

  actionNext(textList, lastTextAreaShowId) {
    const beginingId = lastTextAreaShowId >= textList.length ? 0 : lastTextAreaShowId;
    const endId =
      // eslint-disable-next-line no-nested-ternary
      beginingId === 0
        ? textList.length > MAX_TEXT_AREA_SHOW
          ? MAX_TEXT_AREA_SHOW
          : textList.length
        : lastTextAreaShowId + MAX_TEXT_AREA_SHOW > textList.length
        ? textList.length
        : lastTextAreaShowId + MAX_TEXT_AREA_SHOW;

    this.setShowTextArea(textList, beginingId, endId);
  }

  // eslint-disable-next-line class-methods-use-this
  generateTextAreaContent(showTextList) {
    if (!showTextList) return null;
    let i = 0;
    const viewTextArea = showTextList.map((text) => {
      i += 1;
      return (
        <div
          key={i}
          className="textRow "
        >
          <span>{text}</span>
          <br />
        </div>
      );
    });
    return viewTextArea;
  }

  render() {
    const {fontSize, isFullView} = this.props;
    const style = {
      constraint: {
        fontSize,
      },
    };
    const {showTextList, totalPage, activePage} = this.state;
    const listContentWidth = isFullView === true ? 'col-md-12' : 'col-md-11';
    return (
      <div
        className=" mainTextArea"
        style={style.constraint}
      >
        <div className={`${listContentWidth} col-textArea `}>
          {this.generateTextAreaContent(showTextList, listContentWidth)}
        </div>
        {!isFullView && (
          <div className="col-md-1 col-navigator">
            <VerticalNavigation
              onClick={this.onClick}
              totalPage={totalPage}
              activePage={activePage}
            />
          </div>
        )}
      </div>
    );
  }
}

TextArea.propTypes = {
  textList: PropTypes.array,
  fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isFullView: PropTypes.bool,
};

TextArea.defaultProps = {
  textList: [],
  fontSize: 16,
  isFullView: false,
};

export default TextArea;
